function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus({ preventScroll: true });
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach(video => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach(model => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus({ preventScroll: true });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach(button =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`
    }
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach(summary =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach(button =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach(details => {
        details.removeAttribute("open");

        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");

        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]')?.addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    const ownerSection = this.closest('.shopify-section');
    if (ownerSection) this.dataset.portalOwnerSection = ownerSection.id;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

document.addEventListener('shopify:section:unload', event => {
  const ownerSectionId = event.target?.id;
  if (!ownerSectionId) return;

  document.querySelectorAll('[data-portal-owner-section]').forEach(dialog => {
    if (dialog.dataset.portalOwnerSection !== ownerSectionId) return;
    if (dialog.hasAttribute('open') && typeof dialog.hide === 'function') dialog.hide();
    dialog.remove();
  });
});

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItems[0].clientWidth
    );
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
        : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define("slider-component", SliderComponent);

const NBIS_DEBUG = false;
const nbisDebug = (message, data) => {
  if (!NBIS_DEBUG) return;
  if (typeof data === 'undefined') {
    console.info(`[Variant/NBIS] ${message}`);
  } else {
    console.info(`[Variant/NBIS] ${message}`, data);
  }
};

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    // Capture the change before custom UI code can stop propagation. Using a
    // single listener is important: registering the same handler in both
    // phases runs the variant AJAX flow twice for one radio-button change.
    this.addEventListener("change", this.onVariantChange, true);
  }

  connectedCallback() {
    // initialize options and availability on mount
    this.updateOptions();
    this.updateOptionAvailability();
    this.updateOptions();
    this.updateMasterId();
    this.updateLowStockStatus();
  }

  onVariantChange(event) {
    nbisDebug('Variant change received', {
      selectedValues: Array.from(this.querySelectorAll('input[type="radio"]:checked, select')).map(input => input.value)
    });
    this.updateOptions();
    // update availability of other option values based on current selection
    this.updateOptionAvailability();
    this.updateOptions();
    this.updateMasterId();
    this.updateLowStockStatus();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput(event);
      this.renderProductInfo();
    }
  }

  /**
   * Enable/disable option values (select options or radio inputs)
   * depending on whether any available variant exists for the
   * current partial selection when that value is chosen.
   */
  updateOptionAvailability() {
    const variantData = this.getVariantData();

    // gather current selections (may contain nulls)
    const current = this.options || [];

    // If using selects
    const selects = Array.from(this.querySelectorAll('select'));
    if (selects.length) {
      selects.forEach((select, optionIndex) => {
        Array.from(select.options).forEach(opt => {
          // skip placeholder/disabled display options which may have empty value
          const value = opt.value;
          if (!value) return;

          const allowed = variantData.some(variant => {
            if (!variant.available) return false;
            // variant.options is array-like, compare each option
            for (let i = 0; i < variant.options.length; i++) {
              const sel = current[i];
              if (i === optionIndex) {
                if (variant.options[i] != value) return false;
              } else if (sel) {
                if (variant.options[i] != sel) return false;
              }
            }
            return true;
          });

          if (allowed) {
            opt.removeAttribute('disabled');
          } else {
            opt.setAttribute('disabled', true);
            // if currently selected value becomes disabled, clear selection
            if (select.value === value) {
              select.value = '';
            }
          }
        });
      });
      return;
    }

    // If using radios (fieldsets)
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    if (fieldsets.length) {
      fieldsets.forEach((fieldset, optionIndex) => {
        const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        inputs.forEach(input => {
          const value = input.value;
          const allowed = variantData.some(variant => {
            if (!variant.available) return false;
            for (let i = 0; i < variant.options.length; i++) {
              const sel = current[i];
              if (i === optionIndex) {
                if (variant.options[i] != value) return false;
              } else if (sel) {
                if (variant.options[i] != sel) return false;
              }
            }
            return true;
          });

          // Keep radios selectable but mark them visually/semantically as
          // unavailable. This allows users to click them (for UX reasons)
          // while still communicating the sold-out state.
          if (!allowed) {
            input.classList.add('disabled');
            input.setAttribute('aria-disabled', 'true');
            try {
              const label = this.querySelector(`label[for="${input.id}"]`);
              if (label) {
                label.setAttribute('data-sold-out-tooltip', window.variantStrings?.getNotified || 'Get notified!');
              }
            } catch (e) {}
          } else {
            input.classList.remove('disabled');
            input.removeAttribute('aria-disabled');
            try {
              const label = this.querySelector(`label[for="${input.id}"]`);
              if (label) {
                label.removeAttribute('data-sold-out-tooltip');
              }
            } catch (e) {}
          }
        });
      });
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      select => select.value
    );
  }

  updateMasterId() {
    if (this.options.some((option) => !option)) {
      this.currentVariant = null;
      return;
    }

    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    // Keep the Gift Card entry address when its displayed product comes from
    // a currency block. Other Product/Quick View URL behavior is unchanged.
    if (this.hasAttribute('data-currency-gift-page')) return;
    if (!this.currentVariant) {
      nbisDebug('URL update skipped', {
        hasVariant: false
      });
      return;
    }

    if (this.dataset.updateUrl === 'false') {
      const detail = {
        variantId: this.currentVariant.id,
        available: this.currentVariant.available,
        sectionId: this.dataset.section,
        source: 'quick-add'
      };
      nbisDebug('Quick-add variant changed', detail);
      window.dispatchEvent(new CustomEvent('variant:quickadd-change', { detail }));
      return;
    }

    const previousUrl = window.location.href;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);

    if (window.location.href !== previousUrl) {
      nbisDebug('Variant URL changed', {
        from: previousUrl,
        to: window.location.href,
        variantId: this.currentVariant.id,
        available: this.currentVariant.available
      });
      window.dispatchEvent(new CustomEvent('variant:urlchange', {
        detail: {
          variantId: this.currentVariant.id,
          available: this.currentVariant.available
        }
      }));
    } else {
      nbisDebug('URL already represents selected variant', {
        url: window.location.href,
        variantId: this.currentVariant.id
      });
    }
  }

  updateVariantInput(event) {
    // Keep every Shopify product-id input in sync. SC Back in Stock attaches
    // direct listeners only to the first add-to-cart form it finds. Update all
    // matching inputs, then notify exactly that one watched input once.
    const productForms = document.querySelectorAll([
      `#product-form-${this.dataset.section}`,
      '#product-form-installment',
      `#product-form-installment-${this.dataset.section}`
    ].join(', '));
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;

      input.value = this.currentVariant.id;
    });

    const appWatchedForm = document.querySelector('form[action="/cart/add"]');
    const appWatchedVariantInput = appWatchedForm?.querySelector('input[type="hidden"][name="id"]');
    const nativeControlAlreadyNotifiesApp = event?.target instanceof Element &&
      appWatchedForm?.contains(event.target);

    if (!nativeControlAlreadyNotifiesApp) {
      appWatchedVariantInput?.dispatchEvent(new Event("change"));
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  getLowStockVariantData() {
    const dataScript = document.querySelector(
      `[data-low-stock-variant-data][data-section="${this.dataset.section}"]`
    );
    if (!dataScript) return [];

    try {
      return JSON.parse(dataScript.textContent);
    } catch (e) {
      return [];
    }
  }

  getLowStockMessage(variant) {
    if (!variant || !variant.available || !variant.inventory_management || variant.inventory_policy !== 'deny') {
      return '';
    }

    const quantity = Number(variant.inventory_quantity);
    if (!Number.isFinite(quantity) || quantity < 1 || quantity > 15) return '';
    const status = document.querySelector(
      `[data-low-stock-status][data-section="${this.dataset.section}"]`
    );
    if (quantity === 1) return status?.dataset.lastOne || 'Last one remaining!';
    if (quantity === 2) return status?.dataset.only2Left || 'Only 2 left!';
    if (quantity === 3) return status?.dataset.only3Left || 'Only 3 left!';
    return status?.dataset.onlyAFewLeft || 'Only a few left!';
  }

  updateLowStockStatus() {
    const status = document.querySelector(
      `[data-low-stock-status][data-section="${this.dataset.section}"]`
    );
    if (!status) return;

    const variantData = this.getLowStockVariantData();
    const currentVariantId = Number(this.currentVariant?.id);
    const currentVariant = variantData.find((variant) => Number(variant.id) === currentVariantId);
    const message = this.getLowStockMessage(currentVariant);

    status.textContent = message;
    status.classList.toggle('product__low-stock-status--hidden', !message);
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const requestedVariantAvailable = this.currentVariant.available;

    if (this.hasAttribute('data-currency-gift-page')) {
      // The entry URL may belong to another product (or a regular page).
      // Use the displayed gift card's prices instead of fetching that URL's product.
      const section = this.closest('[id^="MainProduct-"]');
      const price = section?.querySelector(`#price-${this.dataset.section}`);
      const source = section?.querySelector(`template[data-gift-card-price="${requestedVariantId}"]`);
      if (source && price) {
        price.replaceChildren(source.content.cloneNode(true));
        price.classList.remove('visibility-hidden');
      }
      this.toggleAddButton(!requestedVariantAvailable, window.variantStrings.soldOut);
      return;
    }

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // A slower response for an earlier click must never overwrite the
        // currently selected variant or release its modal trigger.
        if (String(this.currentVariant?.id) !== String(requestedVariantId)) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const variantPickerDestination = document.querySelector(`variant-radios[data-section=${this.dataset.section}]`);
        const variantPickerSource = html.querySelector(`variant-radios`);

        if (variantPickerSource && variantPickerDestination) {
          variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
          // If the destination is an instance of our custom element, re-run
          // its option wiring so disabled/enabled states reflect the new HTML.
          if (typeof variantPickerDestination.updateOptions === 'function') {
            variantPickerDestination.updateOptions();
          }
          if (typeof variantPickerDestination.updateOptionAvailability === 'function') {
            variantPickerDestination.updateOptionAvailability();
          }
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!requestedVariantAvailable, window.variantStrings.soldOut);

        const addButton = document
          .getElementById(`product-form-${this.dataset.section}`)
          ?.querySelector('.product-form__submit');
        let soldOutorComingSoonString = window.variantStrings.soldOut;
        if(addButton?.innerHTML.indexOf("Coming soon") !== -1) {
          soldOutorComingSoonString = "Coming soon"
        }

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !requestedVariantAvailable,
          soldOutorComingSoonString
        );

        window.dispatchEvent(new CustomEvent('variant:productinfo-rendered', {
          detail: {
            variantId: requestedVariantId,
            available: requestedVariantAvailable
          }
        }));
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');

    if (!addButton) return;

    addButton.classList.remove("product-form__submit--choose-size");

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.classList.add("product-form__submit--choose-size");
    addButton.textContent = 'Select size';
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
      const fieldsets = this.querySelectorAll("fieldset");
      this.options = Array.from(fieldsets).map(fieldset => {
          const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
          return checkedRadio ? checkedRadio.value : null;
      });
  }
}

customElements.define("variant-radios", VariantRadios);

// Open the back-in-stock modal after a sold-out variant selection and after the
// app has finished inserting its button following the product AJAX update.
(function initBackInStockOnVariantChange() {
  // Scope this to SC's real React root. The mobile sticky bar creates clones
  // with the same class, but those clones can still target the old variant.
  const BUTTON_SELECTOR = '#esc-oos-form .NBIS-Modal__btn';
  const MODAL_TRIGGER_SELECTOR = [
    '.NBIS-Modal__btn',
    '.product-form__fixed-notify',
    '.esc-nbis-sticky-button'
  ].join(', ');
  const MODAL_CLOSE_SELECTOR = '.NBIS-Modal__close';
  const VISIBLE_MODAL_SELECTOR = '.NBIS-Modal__overlay_visible';
  const MODAL_VARIANT_SELECTOR = '#esc-oos-form .NBIS-Modal__variant';
  const OBSERVER_TIMEOUT_MS = 10000;
  const BUTTON_SETTLE_MS = 50;
  let buttonObserver;
  let observerTimeout;
  let buttonCheckInterval;
  let isWaiting = false;
  let waitStartedAt = 0;
  let staleButtons = new Set();
  let buttonCandidate = null;
  let buttonCandidateSince = 0;
  let waitingVariantId = null;
  let productInfoRendered = false;
  let clickButtonWhenReady = null;
  let backInStockModalOpen = false;
  let quickAddFocusTrapWasReleased = false;

  function isQuickAddBackInStockModalVisible() {
    return !!document.querySelector(
      'body > #esc-oos-form[data-quick-add-back-in-stock-root="true"] .NBIS-Modal__overlay_visible'
    );
  }

  function preventBackInStockAnchorJump(clickEvent) {
    const eventTarget = clickEvent.target;
    if (!(eventTarget instanceof Element)) return;

    const closeButton = eventTarget.closest(MODAL_CLOSE_SELECTOR);
    if (closeButton) {
      // SC uses href="#" for closing, which otherwise jumps to page top.
      clickEvent.preventDefault();
      return;
    }

    const button = eventTarget.closest(MODAL_TRIGGER_SELECTOR);
    if (!button) return;

    // Allow NBIS' click handler to run, but prevent native anchor navigation
    // for the original button, its mobile clone and automatic clicks.
    clickEvent.preventDefault();
  }

  document.addEventListener('click', preventBackInStockAnchorJump, true);

  const modalVisibilityObserver = new MutationObserver(() => {
    const modalIsVisible = !!document.querySelector(VISIBLE_MODAL_SELECTOR);
    if (modalIsVisible === backInStockModalOpen) return;
    backInStockModalOpen = modalIsVisible;

    // Give the app focus while it sits above Quick View, without fixing the
    // document or restoring a stale scroll position when the dialog closes.
    if (modalIsVisible) {
      quickAddFocusTrapWasReleased = isQuickAddBackInStockModalVisible();
      if (quickAddFocusTrapWasReleased) removeTrapFocus();
    } else if (quickAddFocusTrapWasReleased) {
      const openQuickAdd = document.querySelector('quick-add-modal[open]');
      const quickAddDialog = openQuickAdd?.querySelector('[role="dialog"]');
      if (openQuickAdd && quickAddDialog) trapFocus(openQuickAdd, quickAddDialog);
      quickAddFocusTrapWasReleased = false;
    }
  });
  modalVisibilityObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });

  function stopWaiting(reason) {
    buttonObserver?.disconnect();
    window.clearTimeout(observerTimeout);
    window.clearInterval(buttonCheckInterval);
    if (isWaiting && reason) nbisDebug(`Stopped waiting: ${reason}`);
    isWaiting = false;
    waitStartedAt = 0;
    staleButtons = new Set();
    buttonCandidate = null;
    buttonCandidateSince = 0;
    waitingVariantId = null;
    productInfoRendered = false;
    clickButtonWhenReady = null;
  }

  function getReadyBackInStockButton() {
    const modalVariantSelect = document.querySelector(MODAL_VARIANT_SELECTOR);
    const modalMatchesVariant = modalVariantSelect &&
      String(modalVariantSelect.value) === String(waitingVariantId);

    return Array.from(document.querySelectorAll(BUTTON_SELECTOR)).find((button) => {
      if (button.disabled) return false;

      const styles = window.getComputedStyle(button);
      if (styles.display === 'none' || styles.visibility === 'hidden') return false;

      // For products with several variants, SC exposes its currently active
      // variant through the modal select. This is the authoritative readiness
      // signal even when React reuses the same button node. For a single-
      // variant product there is no select, so fall back to a newly inserted
      // button (sold-out to sold-out cannot occur in that case).
      return modalVariantSelect ? modalMatchesVariant : !staleButtons.has(button);
    }) || null;
  }

  function waitForBackInStockButton(event) {
    nbisDebug('NBIS trigger received', event.detail);
    stopWaiting('superseded by a new variant change');

    // An available variant should never open the back-in-stock modal. This
    // also prevents a button left over from the previous variant being used.
    if (event.detail?.available !== false) {
      nbisDebug('NBIS modal skipped because variant is available');
      return;
    }

    staleButtons = new Set(document.querySelectorAll(BUTTON_SELECTOR));
    waitingVariantId = event.detail.variantId;
    productInfoRendered = false;
    isWaiting = true;
    waitStartedAt = Date.now();
    nbisDebug('Waiting for a fresh visible .NBIS-Modal__btn', {
      timeoutMs: OBSERVER_TIMEOUT_MS,
      staleButtonCount: staleButtons.size
    });

    clickButtonWhenReady = function() {
      if (!productInfoRendered) return false;

      const button = getReadyBackInStockButton();
      if (!button) {
        buttonCandidate = null;
        buttonCandidateSince = 0;
        return false;
      }

      // Give SC one short task boundary to finish attaching the click handler
      // after inserting or updating the button.
      if (button !== buttonCandidate) {
        buttonCandidate = button;
        buttonCandidateSince = Date.now();
        return false;
      }
      if (Date.now() - buttonCandidateSince < BUTTON_SETTLE_MS) return false;

      nbisDebug('Visible NBIS button found; clicking', {
        text: button.textContent?.trim(),
        className: button.className,
        waitedMs: Date.now() - waitStartedAt
      });
      stopWaiting('button found');
      button.click();
      return true;
    };

    buttonObserver = new MutationObserver(() => {
      clickButtonWhenReady?.();
    });

    buttonObserver.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true
    });

    // The app sometimes reuses an unchanged button, which produces no useful
    // child-list mutation. Poll briefly as a fallback after its change handler.
    buttonCheckInterval = window.setInterval(clickButtonWhenReady, 50);
    observerTimeout = window.setTimeout(
      () => stopWaiting('timed out without finding a visible button'),
      OBSERVER_TIMEOUT_MS
    );
  }

  function markProductInfoRendered(event) {
    if (!isWaiting || String(event.detail?.variantId) !== String(waitingVariantId)) return;

    // The button may finish rendering before or after the product section's
    // request. Requiring both signals is sufficient; do not mark the newly
    // rendered SC button as stale merely because it won that race.
    productInfoRendered = true;
    clickButtonWhenReady?.();
  }

  nbisDebug('NBIS variant-change listeners initialized');
  window.addEventListener('variant:urlchange', waitForBackInStockButton);
  window.addEventListener('variant:quickadd-change', waitForBackInStockButton);
  window.addEventListener('variant:productinfo-rendered', markProductInfoRendered);
})();

// ---- Cart compatibility emitter (idempotent + debounced) ----
(function(){
  // simple debounce so rapid calls don't re-open twice
  const EMIT_DEBOUNCE_MS = 300;
  let lastEmitAt = 0;

  function isSlideCartOpen() {
    // covers both the drawer and its overlay
    return !!document.querySelector('.slidecarthq.open') ||
           !!document.querySelector('#slidecarthq .slidecarthq.open') ||
           !!document.querySelector('#slidecarthq .slidecarthq-overlay.open');
  }

  async function _emitCartCompat(source = 'custom-add', { openIfClosed = true } = {}) {
    const now = Date.now();
    if (now - lastEmitAt < EMIT_DEBOUNCE_MS) return; // prevent double-open races
    lastEmitAt = now;

    // 1) Get the canonical cart object
    let cart = null;
    try {
      cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
    } catch (e) {
      console.warn('emitCartCompat: /cart.js failed', e);
    }

    const opened = isSlideCartOpen();

    // 2) Update SlideCart, only OPEN if it's currently closed
    try {
      if (cart && typeof window.SLIDECART_SET_CART === 'function') {
        window.SLIDECART_SET_CART(cart);
      } else if (cart && typeof window.SLIDECART_UPDATE === 'function') {
        window.SLIDECART_UPDATE(cart);
      } else if (typeof window.SLIDECART_RELOAD === 'function') {
        window.SLIDECART_RELOAD();
      }

      // ✅ only open if closed (prevents second drawer)
      if (!opened && openIfClosed && typeof window.SLIDECART_OPEN === 'function') {
        window.SLIDECART_OPEN();
      }
    } catch (e) {
      console.warn('emitCartCompat: Slide Cart API error', e);
    }

    // 3) Broadcast common cart events
    const detail = { cart, cartData: cart, source };
    const domEvents = [
      'cart:updated', 'cart:change', 'cart:refresh',
      'product:added', 'ajaxProduct:added', 'added.ajaxCart',
      'theme:cart:change'
    ];
    domEvents.forEach(name => {
      try { document.dispatchEvent(new CustomEvent(name, { detail })); } catch (_) {}
    });

    try {
      if (window.PUB_SUB_EVENTS && window.publish) {
        const E = window.PUB_SUB_EVENTS;
        [E?.cartUpdate, E?.quantityUpdate, E?.cartError]
          .filter(Boolean)
          .forEach(t => { try { window.publish(t, { ...detail }); } catch (_) {} });
      }
    } catch (_) {}

    try {
      if (window.jQuery) {
        const $ = window.jQuery;
        $(document).trigger('cart:updated', [detail]);
        $(document).trigger('cart:change', [detail]);
        $(document).trigger('ajaxProduct:added', [detail]);
        $(document).trigger('added.ajaxCart', [detail]);
      }
    } catch (_) {}
  }

  // expose once
  if (!window.emitCartCompat) {
    window.emitCartCompat = _emitCartCompat;
  }
})();

/*
 * Mobile sticky add-to-cart: create a fixed bottom bar with a cloned
 * add-to-cart button on small screens. Show it after the last product
 * accordion has scrolled out of view. Keep the cloned
 * button text in sync with the original. In the "select size" state,
 * clicking the fixed button returns to the picker. Sold-out and other
 * unavailable purchase actions stay hidden.
 */
(function() {
  const MOBILE_MAX = 749; // <750px
  const SOLD_OUT_NOTIFY_LABEL = 'NOTIFY ME';
  let instances = [];
  const PRIMARY_NOTIFY_BUTTON_SELECTOR = '.NBIS-Modal__btn';
  const FALLBACK_NOTIFY_BUTTON_SELECTORS = [
    '.esc-btn-modal',
    '.esc-nbis-sticky-btn .esc-nbis-sticky-button',
    '.esc-nbis-sticky-button'
  ].join(', ');

  function initStickyForForm(form) {
    if (!form) return;
    // Quick View owns its purchase action inside the modal. Creating the PDP
    // mobile sticky clone for an injected Quick View form produces a second
    // button outside the modal and can place it above the backdrop.
    if (form.closest('quick-add-modal')) return;
    const addButton = form.querySelector('[name="add"]');
    if (!addButton) return;

    // avoid duplicate initialization
    if (instances.some(i => i.form === form)) return;

  const fixed = document.createElement('div');
  fixed.className = 'product-form__fixed';
  // The stylesheet keeps this purchase action below the header and drawers.
  const clone = addButton.cloneNode(true);
  // ensure clone doesn't accidentally submit if placed outside form
  clone.removeAttribute('form');
  // Select size navigates to the picker even when native submission is disabled.
  clone.removeAttribute('disabled');
    document.body.appendChild(fixed);

    const productFormEl = form.closest('.product__info-container') || form.closest('.product') || form.closest('[id^="MainProduct-"]');
    const variantIdInput = form.querySelector('input[name="id"]');
    let isSyncing = false;
    let isDestroyed = false;
    let activeNotifyButton = null;
    let activeNotifyButtonObserver = null;

    // helper: find variant picker for this section/form
    function findVariantPicker() {
      // try to get section id from form id like product-form-<sectionId>
      const formEl = form;
      let sectionId = null;
      try {
        if (formEl && formEl.id && typeof formEl.id === 'string' && formEl.id.indexOf('product-form-') === 0) {
          sectionId = formEl.id.replace('product-form-', '');
        }
      } catch (e) {
        // Fall back to locating the picker within the product container.
      }
      if (sectionId) {
        const vr = document.querySelector(`variant-radios[data-section="${sectionId}"]`) || document.querySelector(`variant-selects[data-section="${sectionId}"]`);
        if (vr) return vr;
      }
      // fallback: find first variant picker within the same product container
      if (productFormEl) {
        return productFormEl.querySelector('variant-radios, variant-selects');
      }
      return document.querySelector('variant-radios, variant-selects');
    }

    function isElementVisible(element) {
      if (!element || !element.isConnected) return false;
      const style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }

    function findNotifyButton() {
      const scope = productFormEl || document;
      const primaryButtons = Array.from(scope.querySelectorAll(PRIMARY_NOTIFY_BUTTON_SELECTOR));
      if (primaryButtons.length) return primaryButtons.find(isElementVisible) || primaryButtons[0];

      const fallbackButtons = Array.from(scope.querySelectorAll(FALLBACK_NOTIFY_BUTTON_SELECTORS));
      return fallbackButtons.find(isElementVisible) || fallbackButtons[0] || null;
    }

    function applyNotifyLabel(button) {
      if (!button) return;
      if (button.textContent !== SOLD_OUT_NOTIFY_LABEL) {
        button.textContent = SOLD_OUT_NOTIFY_LABEL;
      }
      if (button.getAttribute('aria-label') !== SOLD_OUT_NOTIFY_LABEL) {
        button.setAttribute('aria-label', SOLD_OUT_NOTIFY_LABEL);
      }
      if (button.getAttribute('title') !== SOLD_OUT_NOTIFY_LABEL) {
        button.setAttribute('title', SOLD_OUT_NOTIFY_LABEL);
      }
    }

    function syncNotifyButtonObserver(button) {
      if (activeNotifyButton === button) return;

      if (activeNotifyButtonObserver) {
        activeNotifyButtonObserver.disconnect();
        activeNotifyButtonObserver = null;
      }

      activeNotifyButton = button;

      if (!button) return;

      activeNotifyButtonObserver = new MutationObserver(() => {
        if (isSyncing) return;
        applyNotifyLabel(button);
      });
      activeNotifyButtonObserver.observe(button, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true
      });
    }

    function getVariantDataSource() {
      if (productFormEl) {
        const picker = productFormEl.querySelector('variant-radios, variant-selects');
        if (picker && typeof picker.getVariantData === 'function') {
          try {
            return picker.getVariantData();
          } catch (e) {}
        }
        const jsonScript = picker?.querySelector?.('[type="application/json"]');
        if (jsonScript?.textContent) {
          try {
            return JSON.parse(jsonScript.textContent);
          } catch (e) {}
        }
      }
      return [];
    }

    function getCurrentVariant() {
      const currentVariantId = Number(variantIdInput?.value || 0);
      if (!currentVariantId) return null;
      const variantData = getVariantDataSource();
      return variantData.find((variant) => Number(variant.id) === currentVariantId) || null;
    }

    function isSoldOutState() {
      const currentVariant = getCurrentVariant();
      if (currentVariant) return currentVariant.available === false;

      const buttonText = (addButton.textContent || '').trim().toLowerCase();
      const soldOutText = (window.variantStrings?.soldOut || 'sold out').trim().toLowerCase();
      return addButton.hasAttribute('disabled') && (buttonText === soldOutText || buttonText.includes('sold out'));
    }

    function syncPrimaryButtonVisibility() {
      const notifyButton = findNotifyButton();
      syncNotifyButtonObserver(notifyButton);
      if (notifyButton && isSoldOutState() && addButton.hasAttribute('disabled')) {
        applyNotifyLabel(notifyButton);
      }
    }

    function renderFixedButton() {
      if (clone.parentElement !== fixed) fixed.replaceChildren(clone);
      fixed.dataset.mode = 'add';
    }

    // sync state from original button to clone
    function syncClone() {
      if (isDestroyed || isSyncing) return;
      isSyncing = true;
      try {
        // Select size is an enabled navigation action even when the original
        // submit is disabled. Unavailable purchase actions are hidden below.
        clone.removeAttribute('aria-disabled');

        // copy text content (prefer innerText)
        if (clone.textContent !== addButton.textContent) {
          clone.textContent = addButton.textContent;
        }

        syncPrimaryButtonVisibility();
        renderFixedButton();
      } finally {
        isSyncing = false;
      }
      onScroll();
    }

    syncClone();

  // helper to scroll the page so the picker is visible in a reliable way

    function getScrollContainer(el) {
      let node = el.parentElement;
      while (node && node !== document.body && node !== document.documentElement) {
        const style = window.getComputedStyle(node);
        const overflowY = style.overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll') return node;
        node = node.parentElement;
      }
      return window;
    }

    function scrollToPicker(picker) {
      if (!picker) return;
  const header = document.querySelector('header');
  const headerHeight = header ? header.getBoundingClientRect().height : 0;
  const gap = 12; // small breathing room
    const EXTRA_OFFSET = 12; // smaller offset to avoid overscrolling

      const scroller = getScrollContainer(picker);

      // record scroller and initial rect (no debug logging in production)

      function isPickerVisible() {
        try {
          const pickerRect = picker.getBoundingClientRect();
          if (scroller === window) {
            const top = pickerRect.top;
            const bottom = pickerRect.bottom;
            const winH = window.innerHeight || document.documentElement.clientHeight;
            // consider header height and a small gap
            return (top >= headerHeight + gap) && (bottom <= winH - gap);
          } else {
            const scrollerRect = scroller.getBoundingClientRect();
            // visible if picker sits within scroller's viewport (with gap)
            return (
              pickerRect.top >= scrollerRect.top + headerHeight + gap &&
              pickerRect.bottom <= scrollerRect.bottom - gap
            );
          }
        } catch (e) {
          return false;
        }
      }

      function doScrollAttempt(attemptsLeft) {
        const pickerRect = picker.getBoundingClientRect();

        // Primary: use scrollIntoView which handles most nested/scrolling contexts.
        try {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
           // After a short delay, focus first interactive element
           setTimeout(() => {
             try {
               const focusable = picker.querySelector('input[type="radio"], select, input, button, [tabindex]:not([tabindex^="-"])');
               if (focusable) {
                 focusable.focus({ preventScroll: true });
               }
             } catch (e) {}
           }, 350);
           return;
         } catch (e) {
           // fall through to legacy calculation
         }

         if (scroller === window) {
           const targetY = window.pageYOffset + pickerRect.top - headerHeight - gap - EXTRA_OFFSET;
           try {
             window.scrollTo({ top: Math.max(0, Math.floor(targetY)), behavior: 'smooth' });
           } catch (e) {
             try { window.scrollTo(0, Math.max(0, Math.floor(targetY))); } catch (_) {}
           }
         } else {
           const scrollerRect = scroller.getBoundingClientRect();
           const currentScroll = scroller.scrollTop;
           const offset = pickerRect.top - scrollerRect.top + currentScroll - headerHeight - gap - EXTRA_OFFSET;
           try {
             scroller.scrollTo({ top: Math.max(0, Math.floor(offset)), behavior: 'smooth' });
           } catch (e) {
             scroller.scrollTop = Math.max(0, Math.floor(offset));
           }
         }

         // after a short delay check if visible; otherwise retry up to a cap
         setTimeout(() => {
           const visible = isPickerVisible();
           if (visible) {
             // focus first interactive element
             try {
               const focusable = picker.querySelector('input[type="radio"], select, input, button, [tabindex]:not([tabindex^="-"])');
               if (focusable) focusable.focus({ preventScroll: true });
             } catch (e) {
               try { const focusable = picker.querySelector('input[type="radio"], select, input, button, [tabindex]:not([tabindex^="-"])'); if (focusable) focusable.focus(); } catch (e) {}
             }
             // ensure fixed bar visible again after a pause
             // recalc whether the fixed bar should be shown (original add button may now be visible)
             setTimeout(() => { onScroll(); }, 300);
             return;
           }

           if (attemptsLeft > 0) {
             // gradually increase delay between attempts
             doScrollAttempt(attemptsLeft - 1);
             return;
           }

           // final fallback: direct scrollIntoView (best-effort)
           try {
             picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
           } catch (e) {
             // ignore
           }
           // attempt to focus anyway
           try {
             const focusable = picker.querySelector('input[type="radio"], select, input, button, [tabindex]:not([tabindex^="-"])');
             if (focusable) focusable.focus({ preventScroll: true });
           } catch (e) {}
           // recalc visibility of fixed bar after final fallback
           setTimeout(() => { onScroll(); }, 500);
         }, 220);
       }

       // start attempts (4 retries total -> 5 attempts)
       doScrollAttempt(4);
     }

     // when clone clicked: if select-size state -> scroll to picker, else trigger original
    clone.addEventListener('click', (evt) => {
      evt.preventDefault();
      // consider both 'select' and 'choose' labels and also respect
      // the explicit 'product-form__submit--choose-size' class which themes
      // use to mark the select-size state.
      const labelText = (clone.textContent || '') + ' | ' + (addButton.textContent || '');
      const hasChooseClass = addButton.classList && addButton.classList.contains('product-form__submit--choose-size');
      const isDisabled = addButton.hasAttribute('disabled');
      const isSelect = hasChooseClass || isDisabled && /select|choose/i.test(labelText) || /select|choose/i.test(labelText);
  // clone click: proceed based on computed state (no debug logging)
      if (isSelect) {
        const picker = findVariantPicker();
  // picker found (scrolling to it)
         if (picker) {
           // hide the fixed bar briefly so it doesn't cover the picker after scroll
           fixed.classList.remove('is-visible');
           scrollToPicker(picker);
           // restore visibility after scroll has likely finished
           // recalc visibility after scroll instead of forcing it visible
           setTimeout(() => { onScroll(); }, 900);
         }
         return;
       }
       // otherwise, trigger original button click (submit flow)
       try { addButton.click(); } catch (e) { addButton.dispatchEvent(new MouseEvent('click', { bubbles: true })); }
     });

    // observe changes on original button to sync clone (text changes, disabled attribute)
    const mo = new MutationObserver(() => {
      if (!isSyncing) syncClone();
    });
    mo.observe(addButton, { attributes: true, childList: true, subtree: true, characterData: true });
    const variantInputObserver = new MutationObserver(() => {
      if (!isSyncing) syncClone();
    });
    if (variantIdInput) {
      variantInputObserver.observe(variantIdInput, { attributes: true, attributeFilter: ['value'] });
      variantIdInput.addEventListener('change', syncClone);
    }
    const notifyObserver = new MutationObserver(() => {
      if (!isSyncing) syncClone();
    });
    if (productFormEl) {
      notifyObserver.observe(productFormEl, { childList: true, subtree: true });
      productFormEl.addEventListener('change', syncClone);
      productFormEl.addEventListener('click', syncClone);
    }

    // Keep the purchase action out of the way until all product accordions
    // have been passed, including the full content of an expanded accordion.
    function onScroll() {
      if (isDestroyed) return;
      const chooseSize = addButton.classList.contains('product-form__submit--choose-size')
        || /select|choose/i.test(addButton.textContent || '');
      const unavailable = !chooseSize && (isSoldOutState() || addButton.disabled
        || addButton.getAttribute('aria-disabled') === 'true');
      if (window.innerWidth > MOBILE_MAX || unavailable) {
        fixed.hidden = true;
        fixed.inert = true;
        fixed.classList.remove('is-visible');
        return;
      }
      fixed.hidden = false;
      const accordions = productFormEl?.querySelectorAll('.product__accordion');
      const lastAccordion = accordions?.[accordions.length - 1];
      const rect = (lastAccordion || addButton).getBoundingClientRect();
      fixed.inert = rect.bottom >= 0;
      if (rect.bottom < 0) {
        fixed.classList.add('is-visible');
      } else {
        fixed.classList.remove('is-visible');
      }
    }

    // use rAF throttling
    let ticking = false;
    function handleScrollRAF() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', handleScrollRAF, { passive: true });
    window.addEventListener('resize', handleScrollRAF);
    const layoutObserver = new ResizeObserver(handleScrollRAF);
    if (productFormEl) layoutObserver.observe(productFormEl);
    onScroll();

    function destroy() {
      if (isDestroyed) return;
      isDestroyed = true;

      mo.disconnect();
      notifyObserver.disconnect();
      variantInputObserver.disconnect();
      activeNotifyButtonObserver?.disconnect();
      layoutObserver.disconnect();
      variantIdInput?.removeEventListener('change', syncClone);
      productFormEl?.removeEventListener('change', syncClone);
      productFormEl?.removeEventListener('click', syncClone);
      window.removeEventListener('scroll', handleScrollRAF);
      window.removeEventListener('resize', handleScrollRAF);
      fixed.remove();
    }

    instances.push({ form, destroy });
  }

  function pruneDisconnectedInstances() {
    instances = instances.filter((instance) => {
      if (instance.form.isConnected) return true;
      instance.destroy();
      return false;
    });
  }

  function initAll() {
    // initialize for all product forms (main product and quick-add forms with id starting product-form-)
    document.querySelectorAll('form[id^="product-form-"]').forEach(initStickyForForm);
  }

  // init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // re-init if new product forms are injected later (quick-add, AJAX updates)
  const bodyObserver = new MutationObserver((mutations) => {
    let removedProductContent = false;

    for (const m of mutations) {
      if (!removedProductContent && m.removedNodes?.length) {
        removedProductContent = Array.from(m.removedNodes).some((node) => (
          node instanceof Element && (
            node.matches('form[id^="product-form-"]') ||
            node.querySelector?.('form[id^="product-form-"]')
          )
        ));
      }
      if (!m.addedNodes || !m.addedNodes.length) continue;

      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (node.matches('form[id^="product-form-"]')) {
          initStickyForForm(node);
          continue;
        }

        const nestedForms = node.querySelectorAll?.('form[id^="product-form-"]');
        if (nestedForms?.length) {
          nestedForms.forEach(initStickyForForm);
        }
      }
    }

    if (removedProductContent) pruneDisconnectedInstances();
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

})();
